import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import "./barChart.css";

const barData = [
  { name: "Jan", series1: 65, series2: 40 },
  { name: "Feb", series1: 60, series2: 70 },
  { name: "Mar", series1: 90, series2: 55 },
  { name: "Apr", series1: 80, series2: 20 },
  { name: "May", series1: 55, series2: 45 },
  { name: "Jun", series1: 60, series2: 70 },
  { name: "Jul", series1: 45, series2: 65 },
];

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div className="custom-bar-tooltip">
        <p className="tooltip-month">{label}</p>
        {payload.map((entry, index) => (
          <p key={index} className="tooltip-item" style={{ color: entry.color }}>
            <span className="tooltip-label">{entry.name === 'series1' ? 'Series 1' : 'Series 2'}:</span>
            <span className="tooltip-value">{entry.value}</span>
          </p>
        ))}
      </div>
    );
  }
  return null;
};

const BarChartComponent = () => {
  return (
    <div className="chart-box bar-chart-box">
      <h3 className="chart-title">Monthly Overview</h3>
      <ResponsiveContainer width="100%" height={350}>
        <BarChart 
          data={barData}
          margin={{ top: 10, right: 20, left: 0, bottom: 5 }}
        >
          <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e0e0e0" opacity={0.5} />
          <XAxis 
            dataKey="name" 
            axisLine={false}
            tickLine={false}
            tick={{ fill: '#666', fontSize: 12, fontWeight: 500 }}
          />
          <YAxis 
            domain={[0, 90]}
            axisLine={false}
            tickLine={false}
            tick={{ fill: '#666', fontSize: 12 }}
          />
          <Tooltip content={<CustomTooltip />} cursor={{ fill: 'rgba(75, 53, 211, 0.1)' }} />
          <Legend 
            verticalAlign="top"
            align="right"
            height={36}
            iconType="circle"
            wrapperStyle={{ paddingBottom: '10px' }}
            formatter={(value, entry) => (
              <span style={{ color: entry.color, fontWeight: 600, fontSize: '13px' }}>
                {value === 'series1' ? 'Series 1' : 'Series 2'}
              </span>
            )}
          />
          <Bar 
            dataKey="series1" 
            fill="#e65100" 
            radius={[8, 8, 0, 0]}
            name="series1"
            maxBarSize={50}
          />
          <Bar 
            dataKey="series2" 
            fill="#4b35d3" 
            radius={[8, 8, 0, 0]}
            name="series2"
            maxBarSize={50}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default BarChartComponent;

